<template>
  <div class="addCourseWrapper">
    <div class="addCourse">
      <div class="title">
        <strong>{{title}}</strong>
      </div>
      <div class="formContent">
        <mt-field v-model="ruleForm.courseName" label="课程标题" placeholder="此项为必填项" type="text" @blur.native.capture="checkInputName"></mt-field>
        <mt-field v-model="ruleForm.courseDescription" label="课程说明" placeholder="请输入" type="text"></mt-field>
        <div class="select-wrapper">
          <p style="padding-bottom:10px;">
            <label for="hzHospital">授课医院:</label>
            <select disabled name="" id="hzHospital" class="hzHospital" placeholder="请输入" v-model="ruleForm.lectureHospitalID">
              <option value="" disabled selected hidden>请输入</option>
              <option v-for="(item, index) in lectureHospitalList" :value="item.id" :key="index">{{item.hospitalName}}</option>
            </select>
          </p>
          <p>
            <label for="hzHospital">授课医生:</label>
            <select disabled name="" id="hzHospital" class="hzHospital" placeholder="请输入" v-model="ruleForm.lectureDoctorID">
              <option value="" disabled selected hidden>请输入</option>
              <option :value="item.id" v-for="(item, index) in lectureDoctorList" :key="index">{{item.userName}}</option>
            </select>
          </p>
        </div>
        <!-- <mt-radio v-if="this.type == 'add'" title="课程周期" :options="['单次', '每周', '每月']" v-model="ruleForm.cycle"></mt-radio> -->
        <div class="radioGroup">
          <span>课程周期</span>
          <div class="radio-inline">
            <input :disabled="isDisabled" v-model="ruleForm.cycle" id="dc" type="radio" name="cycle" value="单次"/>
            <label for="dc">单次</label>
          </div>
          <div class="radio-inline">
            <input :disabled="isDisabled" v-model="ruleForm.cycle" id="mz" type="radio" name="cycle" value="每周" />
            <label for="mz">每周</label>
          </div>
          <div class="radio-inline">
            <input :disabled="isDisabled" v-model="ruleForm.cycle" id="my" type="radio" name="cycle" value="每月" />
            <label for="my">每月</label>
          </div>
        </div>
        <!-- <mt-radio v-if="this.type == 'edit'" title="课程周期" :options="options" v-model="ruleForm.cycle"></mt-radio> -->
        <mt-field v-if="this.type == 'add'" v-model="ruleForm.lectureTime" style="ime-mode:disabled;" label="首次日期" placeholder="此项为必填项" type="datetime" @focus.native.capture="openData"></mt-field>
        <mt-field disabled v-if="this.type == 'edit'" v-model="ruleForm.lectureTime" style="ime-mode:disabled;" label="首次日期" placeholder="请输入" type="datetime" @focus.native.capture="openData"></mt-field>
        <mt-datetime-picker
          ref="picker"
          type="datetime"
          v-model="pickerValue"
          @confirm="handleConfirm"
          :startDate="startDate">
        </mt-datetime-picker>
        <div class="userGroup" style="padding-top:10px;padding-bottom:10px;">
          <span style="display:inline-block;margin:0;width:98px;">医院分组</span>
          <mt-button style="margin-left:2%;" @click="changeUserGroup(item.id)" type="default" size="small" v-for="(item, index) in userGroupList" :key="index">{{item.groupName}}</mt-button>
        </div>
        <div class="select-wrapper" style="padding-left:11px;">
          <!-- <div style="overflow: hidden;padding-right:11px; padding-top:10px;padding-bottom:10px;">
            <label for="hzHospital">对象医院:</label>
            <textarea disabled placeholder="此项为必填项" class="objectHospital" v-model="objHospitalName" @blur="checkInputHospital"></textarea>
          </div> -->
          <div class="objectHospitalList">
            <label for="objectHospitalList">对象医院</label>
            <v-select multiple v-model="objHospitalList" :options="allHospital" @focus.native.capture="cl"></v-select>
          </div>

          <p style="padding-bottom:10px;">
            <label class="hys" for="hzHospital">会议室:</label>
            <select v-if="this.type == 'add'" v-model="ruleForm.boardroomID" name="" id="hzHospital" class="hzHospital" placeholder="请输入">
              <option value="" disabled selected hidden>请输入</option>
              <option v-for="(item, index) in conferenceRoomList" :value="item.hospitalId" :key="index">{{item.hospitalName}}</option>
            </select>
            <select disabled v-if="this.type == 'edit'" v-model="ruleForm.boardroomID" name="" id="hzHospital" class="hzHospital" placeholder="请输入">
              <option value="" disabled selected hidden>请输入</option>
              <option v-for="(item, index) in conferenceRoomList" :value="item.hospitalId" :key="index">{{item.hospitalName}}</option>
            </select>
          </p>
        </div>
        
        <div class="endDate" style="padding-bottom:10px;">
          <label class="endtime" for="endtime">结束时间:</label>
          <span>{{ruleForm.endTime}}</span>
        </div>
        <div style="text-align:right;padding:2%;margin:10px auto;">
          <mt-button type="default" size="small" @click="cancel">取消</mt-button>
          &emsp;
          <mt-button type="primary" size="small" @click="handleSubmit">确认</mt-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { Toast } from 'mint-ui'
import { Indicator } from 'mint-ui'
import moment from 'moment'
import { MessageBox } from 'mint-ui'
export default {
  data() {
    return {
      hasBoardroom: true, // 是否有会议室
      // selected: '',
      isDisabled: false,
      title: '',
      pickerValue: '',  //开始时间
      pickerValue1: '',  //结束时间
      startDate: new Date(),
      lectureHospitalList: [],
      lectureDoctorList: [],
      endDate: new Date(),
      ruleForm: {
        courseName: '',
        lectureHospitalID: '',
        lectureDoctorID: '',
        courseDescription: '', //课程说明
        cycle: '单次',  //课程周期
        targetHospitalID: [],  //对象医院
        boardroomID: '',  //会议室
        endTime: '',  //结束时间
        lectureTime: '' //会诊时间
      },
      objHospitalList: [],
      allHospital: [],
      // objHospitalName: [],
      userGroupList: [],
      conferenceRoomList: [],
      id: this.$route.query.id,
      type: this.$route.query.type,
      allObjHospitalList: [],
    }
  },
  created() {
    this.getAllHospital()
    // this.getObjHospitalList()
    // let curDate = new Date()
    // this.startDate = new Date(curDate.getTime() - 60*60*1000); //前一天
    // this.startDate = new Date()
    // this.endDate = new Date(curDate.getTime() + 60*1000)
    this.getLectureHospital()
    this.getAllGroup(1, 50);
    if (this.type == 'edit') {
      this.title = '编辑课程'
      this.edit()
      this.isDisabled = true
    } else {
      this.title = '新增课程'
      this.isDisabled = false
    }
  },
  methods: {
    cl() {
      // alert(222)
      document.activeElement.blur()
    },
    // 获取所有医院
    getAllHospital() {
      this.Axios.get("/api/Hospital/GetAllHospital").then(res => {
        //获取对象医院
        const data = res.data
        if (data.status == 100) {
          for (let item of data.data) {
            this.allHospital.push({
              label: item.hospitalName,
              value: item.id
            })
          }
        }
      });
    },
    preventShuRuFa(e) {
      e.preventDefault()
    },
    // 检查课程名是否合法
    checkInputName() {
      if (this.ruleForm.courseName == '') {
        Toast({
          message: '课程标题不能为空!',
          position: 'top',
          duration: 1500
        });
      }
    },
    checkInputHospital() {
      if (this.objHospitalList.length <= 0) {
        Toast({
          message: '对象医院不能为空!',
          position: 'top',
          duration: 1500
        });
      }
    },
    // 获取课程信息 初始化编辑数据
    edit() {
      this.Axios.get('/api/LiveCourse/GetInfosByID?liveID=' + this.id).then(res => {
        let data = res.data
        if (data.status == 100) {
          if (data.data.cycle == 1) {
            data.data.cycle = '单次'
          } else if (data.data.cycle == 2) {
            data.data.cycle = '每周'
          } else {
            data.data.cycle = '每月'
          }
          data.data.endTime = moment(data.data.endTime).format('YYYY-MM-DD HH:mm')
          data.data.lectureTime = moment(data.data.lectureTime).format('YYYY-MM-DD HH:mm')
          this.ruleForm = data.data
          // 对象医院
          for (let item of data.data.targetHospitalID) {
            const oId = item
            for (let oItem of this.allHospital) {
              if (oItem.value == oId) {
                this.objHospitalList.push({
                  value: oItem.value,
                  label: oItem.label
                })
                // objHospitalName.push(oItem.hospitalName)
              }
            }
          }
          // this.objHospitalName = objHospitalName
        }
      })
    },
    doEdit() {
      let formData = {}
      formData.courseName = this.ruleForm.courseName
      formData.courseDescription = this.ruleForm.courseDescription
      formData.targetHospitalID = []
      for (let item of this.objHospitalList) {
        formData.targetHospitalID.push(item.value)
      }
      if (this.ruleForm.courseName == '') {
        Toast({
          message: '课程标题不能为空!',
          position: 'top',
          duration: 1500
        });
        return
      }

      if (this.ruleForm.lectureTime == '') {
        Toast({
          message: '首次日期不能为空!',
          position: 'top',
          duration: 1500
        });
        return
      }

      if (this.objHospitalList <= 0) {
        Toast({
          message: '对象医院不能为空!',
          position: 'top',
          duration: 1500
        });
        return
      }
      Indicator.open("加载中...")
      this.Axios.put("/api/LiveCourse/UpdateLiveCourse?id=" + this.ruleForm.id, formData).then(res => {
        // console.log(res.data)
        const data = res.data
        if (data.status == 100) {
          Indicator.close()
          Toast({
            message: '修改成功!',
            position: 'top',
            duration: 1500
          });
          this.$router.push({
            name: 'Education'
          })
        } else {
          Indicator.close()
          Toast({
            message: '修改失败!',
            position: 'top',
            duration: 1500
          });
        }
      })
    },
    openData() {
      // event.preventDefault()
      this.$refs.picker.open()
      document.activeElement.blur()
    },
    // 选择开始时间
    handleConfirm() {
      this.ruleForm.lectureTime = moment(this.pickerValue).format('YYYY-MM-DD HH:mm')
      // this.endDate = this.pickerValue
      let endTime = new Date(new Date(this.pickerValue).getTime() + 30*60*1000)
      // console.log(endTime)
      // this.ruleForm.endTime = new Date(moment(endTime).format('YYYY-MM-DD HH:mm'))
      this.ruleForm.endTime = moment(endTime).format('YYYY-MM-DD HH:mm')
    },
    openData1() {
      this.$refs.picker1.open()
    },
    // 选择结束时间
    handleConfirm1() {
      this.ruleForm.endTime = this.pickerValue1
      this.ruleForm.endTime = moment(this.pickerValue1).format('YYYY-MM-DD HH:mm')
    },
    // 获取授课医院
    getLectureHospital() {
      this.Axios.get("/api/User/GetUserInfo").then(res => {
        //获取授课医院
        const data = res.data
        if (data.status === 100) {
          this.lectureHospitalList.push({
            id: data.ret.hospitalId,
            hospitalName: data.ret.hospitalName
          })
          this.lectureDoctorList.push({
            id: data.ret.userId,
            userName: data.ret.userName
          })
          this.ruleForm.lectureHospitalID = this.lectureHospitalList[0].id
          this.ruleForm.lectureDoctorID = this.lectureDoctorList[0].id
          this.conferenceRoomList = data.ret.boardroom.value
          if (data.ret.boardroom.value.length <= 0) {
            this.hasBoardroom = false
            Toast({
              message: '该用户没有会议室,不能发布课程!',
              position: 'top',
              duration: 2000
            });
          }
        }
      });
    },
    // 获取医院分组
    getAllGroup(pageindex, pagesize) {
      let arr = [];
      this.Axios.get(
        "/api/GroupHospital/GetGroupHospitalList?pageindex=" +
          pageindex +
          "&pagesize=" +
          pagesize
      ).then(res => {
        const data = res.data;
        if (data.status === 100) {
          this.userGroupList = data.data;
        }
      });
    },
    // 选择医院分组
    changeUserGroup(id) {
      this.Axios.get('/api/GroupHospital/GetGroupHospitalInfoById?id=' + id).then(res => {
        const data = res.data
        this.objHospitalList = []
        if (data.status == 100) {
          for (let item of data.data) {
            this.objHospitalList.push({
              label: item.hospitalName,
              value: item.id
            })
          }
        } 
      })
    },
    handleSubmit() {
      if (this.type == 'add') {
        this.addCourse()
      } else {
        this.doEdit()
      }
    },
    // 添加课程
    addCourse() {
      let formData = {
        courseName: this.ruleForm.courseName,
        lectureHospitalID: this.ruleForm.lectureHospitalID,
        lectureDoctorID: this.ruleForm.lectureDoctorID,
        lectureTime: this.ruleForm.lectureTime,
        status: 1,
        courseDescription: this.ruleForm.courseDescription,
        cycle: this.ruleForm.cycle,
        targetHospitalID: [],
        boardroomID: this.ruleForm.boardroomID,
        endTime: this.ruleForm.endTime
      }
      for (let item of this.objHospitalList) {
        formData.targetHospitalID.push(item.value)
      }
      if (formData.boardroomID == '') {
        Toast({
          message: '没有会议室的医院不能发布课程!',
          position: 'top',
          duration: 1500
        });
        return
      }

      if (this.ruleForm.courseName == '') {
        Toast({
          message: '课程标题不能为空!',
          position: 'top',
          duration: 1500
        });
        return
      }

      if (this.ruleForm.lectureTime == '') {
        Toast({
          message: '首次日期不能为空!',
          position: 'top',
          duration: 1500
        });
        return
      }

      if (this.objHospitalList.length <= 0) {
        Toast({
          message: '对象医院不能为空!',
          position: 'top',
          duration: 1500
        });
        return
      }

      if (this.ruleForm.cycle == '单次') {
        formData.cycle = 1
      } else if (this.ruleForm.cycle == '每周') {
        formData.cycle = 2
      } else {
        formData.cycle = 3
      }
      let startTime = this.ruleForm.lectureTime
      Indicator.open("加载中...")
      this.Axios.get("/api/User/JudgeBoardroomInfo?time=" + startTime + "&boardroomId=" + this.ruleForm.boardroomID).then(res => {
        if (res.data.flag && res.data.status === 100) {
          MessageBox.confirm('会议时间段有冲突，是否继续？').then(() => {
            this.Axios.post("/api/LiveCourse/AddLiveCourse", formData).then(res => {
              if (res.data.status) {
                Indicator.close()
                Toast({
                  message: '添加成功!',
                  position: 'top',
                  duration: 1500
                });
                this.$router.push({
                  name: 'Education'
                })
              } else {
                Indicator.close()
                Toast({
                  message: '添加失败!',
                  position: 'top',
                  duration: 1500
                });
              }
            });
          })
        } else if (!res.data.flag && res.data.status === 100) {
          this.Axios.post("/api/LiveCourse/AddLiveCourse", formData).then(res => {
              if (res.data.status) {
                Indicator.close()
                Toast({
                  message: '添加成功!',
                  position: 'top',
                  duration: 1500
                });
                this.$router.push({
                  name: 'Education'
                })
              } else {
                Indicator.close()
                Toast({
                  message: '添加失败!',
                  position: 'top',
                  duration: 1500
                });
              }
            }
          );
        } else {
          Indicator.close()
          this.$message({
            showClose: true,
            message: "内部异常联系管理员!",
            type: "error"
          });
        }
      });
    },
    cancel() {
      this.$router.push({
        name: 'Education'
      })
    }
  }
}
</script>

<style lang="less">
.addCourseWrapper {
  height: 99%;
  background: white;
  overflow-y: auto;
  overflow-x: hidden;
  .addCourse {
    height: 100%;
    .title {
      font-size: 14px;
      height: 3%;
      padding: 2% 2%;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      background: #f5f5f9;
    }
    .formContent {
      .radioGroup {
        height: 48px;
        line-height: 48px;
        padding: 0 10px;
        // border-top: 1px dotted #ccc;
        // border-bottom: 1px dotted #ccc;
        span {
          width: 105px;
          display: block;
          float: left;
        }
        .radio-inline {
          float: left;
          margin-right: 10px;
          input[type="radio"] + label::before {
            content: "\a0";
            display: inline-block;
            vertical-align: middle;
            width: 10px;
            height: 10px;
            margin-right: 5px;
            border-radius: 50%;
            text-indent: .15em;
            margin-bottom: 4px;
            border: 1px solid #CCCCCC;
            padding: 2px;
          }
          input[type="radio"] {
            position: absolute;
            clip: rect(0, 0, 0, 0);
          }
          input[type="radio"]:checked + label::before {
            background-color: #4A90E2;
            background-clip: content-box;
            padding: 2px;
          }
          input[type=radio][disabled]:checked + label::before{
            background-color:#CCCCCC;
            background-clip: content-box;
            padding: 2px;
          }
        }
      }
      .select-wrapper {
        padding-left: 2%;
        .objectHospital {
          border: 1px solid #888;
          float: left;
          width: 62%;
          height: 60px;
          outline: none;
          font-weight: 500;
          font-size: 14px;
          // overflow: auto;
          &::-webkit-input-placeholder {
            /* placeholder颜色  */
            color: #aab2bd;
            /* placeholder字体大小  */
            font-size: 12px;
          }
        }
        label {
          display: inline-block;
          width: 105px;
          float: left;
        }
        
        .hzHospital{
          background: rgba(0,0,0,0);
          width: 55%;
          height: 32px;
          font-family: "微软雅黑";
          font-size: 14px !important;
          color: #aaa !important;
          border: 1px #ccc solid;
          border-radius: 5px;
          color: black !important;
          // margin-left: 2%;
          outline: none;
          &:focus{
            border: 1px #ddd solid;
            box-shadow: 0 0 15px 1px #DDDDDD;
          }
          option{
            color: black !important;
            background: white;
            line-height: 20px;
          }
          // &::-webkit-input-placeholder {
          //   /* placeholder颜色  */
          //   color: #aab2bd;
          //   /* placeholder字体大小  */
          //   font-size: 18px;
          // }
        }
        // .hzHospital[type=select][disabled]:checked{
        //   background-color:#CCCCCC;
        // }
      }
      .userGroup {
        padding-left: 3%;
        span {
          display: inline-block;
          margin-right: 3%;
        }
      }
      .endDate {
        padding: 0 10px 0 10px;
        height: 30px;
        width: 347px;
        display: flex;
        line-height: 30px;
        .endtime {
          display: inline-block;
          width: 105px !important;
        }
        span {
          display: inline-block;
          background: #eee;
          width: 200px;
          height: 27px;
          line-height: 27px;
          cursor: not-allowed;
          text-indent: 5px;
          font-size: 14px;
          border-radius: 4px;
          // font-weight: 600 !important;
        }
      }
      .objectHospitalList {
        margin-top: 10px;
        // border-bottom: 1px dashed #eee;
        padding-bottom: 10px;
        .dropdown-toggle {
          width: 230px !important;
          max-height:200px;
          overflow-y: auto;
          margin: 0 !important;
        }
        .dropdown-menu {
          width: 230px !important;
          margin-left: 105px;
          // z-index: 222;
        }
      }
    }
  }
  input[disabled="disabled"] {
    border-radius: 4px;
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder, select#hzHospital {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-moz-placeholder, textarea::-moz-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-ms-input-placeholder, textarea::-ms-input-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
}
</style>
